module.exports = __webpack_public_path__ + "media/images/new_landing/case/nestle-hero-e2b5a3f68e664bc57c284a92a3429ba1.jpg";